import Vue from 'vue'
import Router from 'vue-router'
import forge from 'node-forge'
Vue.use(Router)

// Get a reference to the VueX store
import store from '../../store'

import AuthRoute from '@/module/auth/route'
import DashboardRoute from '@/module/dashboard/route'

const router = new Router({
    mode: 'history',
    // base: process.env.BASE_URL,
    routes: [
        ...AuthRoute,
        ...DashboardRoute
    ]
})
/**
 * Used to track route using Matomo
 * @param to Route object containing the data about the page to be opened
 */
let trackRoute = function(to) {
    try {
        // hashing the patient Id so that it may not show up raw in matomo dashboard
        let path = to.path
        let hash = null
        if (to.params.id) {
            let md = forge.md.sha256.create()
            md.update(to.params.id)
            hash = parseInt(md.digest().toHex(), 16) % 100000000
            path = path.replace('/' + to.params.id, '')
            if (path[path.length - 1] === '/') path = path.slice(0, path.length - 1)
            // Handling for overview tab
            if (path === '/patient') path += '/overview'
        }

        // tracking/sending the tracked page to matomo
        var _paq = window._paq = window._paq || []
        _paq.push(['setCustomUrl', path])
        _paq.push(['setDocumentTitle', document.title])
        // track the patient_id in url by setting it as custom dimension on Matomo
        if (to.params.id)
            _paq.push(['setCustomDimension', 1, hash])
        _paq.push(['trackPageView'])
        _paq.push(['enableLinkTracking']);

        (function() {
            var u = "https://matomo.doctorbox.com/"
            _paq.push(['setTrackerUrl', u + 'matomo.php'])
            // setting the siteId according to the environment
            if (process.env.NODE_ENV === 'dev')
                _paq.push(['setSiteId', '7'])
            else if (process.env.NODE_ENV === 'production' || process.env.NODE_ENV === 'live')
                _paq.push(['setSiteId', '8'])

            var d = document, g = d.createElement('script'), s = d.getElementsByTagName('script')[0];
            g.type = 'text/javascript'; g.async = true; g.src = u + 'matomo.js'; s.parentNode.insertBefore(g,s);
        })()

    } catch(err) {
        console.error('Problem in Matomo Tracking ', err)
    }
}

router.beforeEach((to, from, next) => {


    /**
     * Restricts localhost and providers on LIVE with doctorbox/doctorplan email
     * from being tracked by matomo.
     */
    try {
        if (location.hostname !== "localhost" && location.hostname !== "127.0.0.1") {
            if (process.env.NODE_ENV === 'dev')
                trackRoute(to)
            else if (['live', 'production'].includes(process.env.NODE_ENV) && store.state.user && store.state.user.user) {
                if (!store.state.user.user.email.includes('@doctorbox') &&
                    !store.state.user.user.email.includes('@doctorplan'))
                    trackRoute(to)
            }
        }
    } catch (err) {
        console.log('Error getting the hostname or unable to access store')
    }


    let authenticationView = to.matched.some((record) => record.meta.authComponent),
        validPath = to.matched.length > 0,
        verified = store.state.auth.verified,
        authenticated = store.state.auth.authenticated

    // Get the URL without a trailing /
    store.state.routeName = (to.fullPath.endsWith('/')) ? to.fullPath.substring(0, to.fullPath.length - 1) : to.fullPath

    // Redirect to the login page
    let loginRedirect = () => {
        // Save the path as a redirect if the path matched an existing path
        store.state.redirect = (validPath) ? to.fullPath : null
        store.state.routeName = '/login'

        // Redirect to the login path
        next({ path: '/login' })
    }

    // If the user is not authenticated and the view is not an authentication view (login, join, etc)
    if (! authenticated && ! authenticationView)
            loginRedirect()

    // If the user is authenticated with an unverified token, or one that may have expired (after 1 day)
    else if (authenticated && (!verified || Date.now() - verified >= 86400000))
        store.dispatch('auth/verify').then(() => {
            next()
        })
        .catch(() => {
            if (authenticationView)
                next()
            else
                loginRedirect()
        })

    // Otherwise the user is authenticated and can proceed, or unauthenticated and can proceed to an authentication view
    else
        next()
})

export default router
